export default {
  MULTIPLE_USERS_EDITING: '846a83d9-dd66-40cb-b9ae-a3afa411bd08',
  MULTIPLE_TABS_EDITING: '7cc32c2e-2efc-4ab0-b9a1-f9b7bf2b907b',
} as const;
